<div class="create-based-on-the-cost__container width__100">
	<p
		class="font__heading-3 font-align__center"
		i18n>
		Costs selected:
	</p>
	<p class="font__heading-3 font-weight__bold margin__bottom--large margin__top--small font-align__center">
		{{ costInvoices.length }}
	</p>
	<p
		class="font__medium font-align__center"
		i18n>
		Select what type of incoming document you want to generate.
	</p>
	<form class="width__100 margin__top--large margin__bottom--large">
		<epic-form-field [text]="textDocumentType">
			<epic-select [control]="formControl">
				@for (dt of documentTypes; track dt) {
					<epic-option
						[text]="dt.text"
						[value]="dt.value" />
				}
			</epic-select>
		</epic-form-field>
	</form>
</div>
<div class="width__100 row justify__end">
	<epic-button
		(onClick)="confirm()"
		size="large">
		<epic-icon name="add" />
		<span>{{ textConfirm }}</span>
	</epic-button>
</div>
